"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./SendPasswordReset.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _mobxReact = require("mobx-react");

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _SendPasswordResetStore = _interopRequireDefault(require("../models/SendPasswordResetStore"));

var _RecaptchaStore = _interopRequireDefault(require("../../shared/models/recaptcha/RecaptchaStore"));

var _SessionPageContent = _interopRequireDefault(require("../components/SessionPageContent"));

var _SessionPageLogo = _interopRequireDefault(require("../components/SessionPageLogo"));

var _CustomForm = _interopRequireDefault(require("../../gradifui/components/form/CustomForm"));

var _CustomInput = _interopRequireDefault(require("../../gradifui/components/form/CustomInput"));

var _CustomSubmit = _interopRequireDefault(require("../../gradifui/components/form/CustomSubmit"));

var _constants = require("../../util/constants");

var _NoRobots = _interopRequireDefault(require("../../shared/components/NoRobots"));

var _reactGrecaptcha = _interopRequireDefault(require("react-grecaptcha"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _class, _class2, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var SendPasswordReset = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(SendPasswordReset, _React$Component);

  var _super = _createSuper(SendPasswordReset);

  function SendPasswordReset() {
    _classCallCheck(this, SendPasswordReset);

    return _super.apply(this, arguments);
  }

  _createClass(SendPasswordReset, [{
    key: "handleSave",
    value: function handleSave(e) {
      e.preventDefault();
      this.props.dispatcher.emit("REQUEST_PASSWORD_RESET");
    }
  }, {
    key: "recaptchaCallback",
    value: function recaptchaCallback(e) {
      this.props.dispatcher.emit("SET_CAPTCHA_TOKEN", {
        response: e,
        formModel: this.props.passwordResetForm
      });
    }
  }, {
    key: "recaptchaExpiredCallback",
    value: function recaptchaExpiredCallback(_) {
      this.props.dispatcher.emit("CLEAR_CAPTCHA_TOKEN", {
        formModel: this.props.passwordResetForm
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _NoRobots.default)();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$session;

      return /*#__PURE__*/_react.default.createElement(_SessionPageContent.default, null, /*#__PURE__*/_react.default.createElement(_SessionPageLogo.default, {
        baseAddress: (_this$props$session = this.props.session) === null || _this$props$session === void 0 ? void 0 : _this$props$session.baseAddress
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h1",
        contentKey: "header",
        className: "content-header"
      }), !this.props.passwordWasReset && /*#__PURE__*/_react.default.createElement(_CustomForm.default, {
        name: "sendPasswordReset",
        form: this.props.passwordResetForm,
        onSubmit: this.handleSave
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "section",
        contentKey: "instructions"
      }), /*#__PURE__*/_react.default.createElement(_CustomInput.default, {
        fieldName: "email",
        placeholder: "Email"
      }), /*#__PURE__*/_react.default.createElement(_reactGrecaptcha.default, {
        className: "recaptcha-component",
        sitekey: this.props.recaptchaSiteKey,
        callback: this.recaptchaCallback,
        expiredCallback: this.recaptchaExpiredCallback
      }), /*#__PURE__*/_react.default.createElement(_CustomSubmit.default, {
        disabled: !this.props.hasCaptchaToken,
        value: "Reset Password"
      }), /*#__PURE__*/_react.default.createElement("section", {
        className: "link-section"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "a",
        contentKey: "backToLogin",
        className: "login-link",
        href: this.props.loginUrl
      }), "\xA0|\xA0", /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "a",
        contentKey: "backToHome",
        className: "home-link",
        href: _constants.URLS.HOME
      }))), this.props.passwordWasReset && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "section",
        contentKey: "resetPasswordAcknowledgment"
      }), /*#__PURE__*/_react.default.createElement("section", {
        className: "link-section"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "a",
        contentKey: "backToHome",
        className: "home-link",
        href: _constants.URLS.HOME
      }))));
    }
  }]);

  return SendPasswordReset;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  passwordWasReset: _propTypes.default.bool,
  passwordResetForm: _propTypes.default.object.isRequired,
  dispatcher: _propTypes.default.object.isRequired
}), _class3), (_applyDecoratedDescriptor(_class2.prototype, "handleSave", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleSave"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "recaptchaCallback", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "recaptchaCallback"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "recaptchaExpiredCallback", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "recaptchaExpiredCallback"), _class2.prototype)), _class2)) || _class;

var propulatedView = (0, _Propulator.default)(SendPasswordReset, {
  sendPasswordResetStore: ["passwordResetForm", "passwordWasReset", "loginUrl"],
  sessionStore: ["session"],
  recaptchaStore: ["hasCaptchaToken", "recaptchaSiteKey"]
});

var _default = (0, _MobxView.default)(propulatedView, {
  sendPasswordResetStore: _SendPasswordResetStore.default,
  recaptchaStore: _RecaptchaStore.default
});

exports.default = _default;